import React, { useCallback, useState, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Container } from 'reactstrap';
import { color } from '~/assets/styles/colors';
import {
	MenuOutlined,
	MenuOpenOutlined,
	ExitToApp,
} from '@mui/icons-material';
import { ExtratoContext } from '~/context/ExtratoContext';
import { Link } from 'react-router-dom';
import { PedidoContext } from '~/context/PedidoContext';
import * as ActionsAuth from '~/store/modules/auth/actions';
import ReactGA from 'react-ga4';
import { NotificacaoContext } from '~/context/NotificacaoContext';
import {
	Bar,
	Sidebar,
	SidebarUl,
	SidebarLi,
	Logo,
	IconeMenu,
	ButtonCss,
	MeusCreditosInfo,
} from './styles';
import Perfil from './Perfil';
import { ClientSidebar } from './Layout/Client';
import Notification from './Notification'
import MasterUserBox from '../MasterUserBox';
import WellcomeBox from '../WellcomeBox';








/* eslint-disable */

export function Header(props) {
	const { user, layout, sidebar, setSidebar, notificacoes, setNotificacoes, dataNotification, setDataNotification } = props;
	const [subSidebar, setSubSidebar] = useState({ active: false, menu: null });
	const [dropdownOpenPerfil, setDropdownOpenPerfil] = useState(false);
	const [dropdownOpenNotificacao, setDropdownOpenNotificacao] = useState(false);
	const dispatch = useDispatch();
	const [creditoValue, setCreditoValue] = useState(0);
	const { getResumo } = useContext(PedidoContext);
	const { getSaldo } = useContext(ExtratoContext);

	const { getNotificacoes } = useContext(NotificacaoContext);
	const [isMobile, setIsMobile] = useState(false);
	let redirectTo = '/client/transacoes';

	const closeSidebars = useCallback(() => {
		setSidebar({ active: false });
		setSubSidebar({ ...subSidebar, active: false });
	}, [subSidebar]);

	function handlerSair() {
		dispatch(ActionsAuth.signOut(user));
		handleClickLogoutGA4();
		handleClickEventGA4("acessar_sair_menu")
	}

	function handleClickLogoutGA4() {
		ReactGA.event({
			category: "logout_click",
			action: "Logout Portal",
			label: "Saindo do Portal",
		});
	}


	function notificationCall() {
		let isMounted = true;

		const fetchData = async () => {
			if (process.env.REACT_APP_ENV === 'PRODUCTION') {
				try {
					const res = await getNotificacoes('', 1);
					if (isMounted && res) {
						setDataNotification(res.data);
						setNotificacoes(res.data.notifications);
					}
				} catch (error) {
					console.error('Erro ao buscar notificações:', error);
				}
			}
		};

		fetchData();

		const interval = setInterval(fetchData, 20000);

		return () => {
			isMounted = false;
			clearInterval(interval);
		};
	}

	useEffect(() => {
		user.dados.permissoes.view_notificacoes && notificationCall()
	}, [getNotificacoes]);


	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768); // Defina a largura de tela que considera como mobile
		};

		handleResize();

		if(user.dados.cargo.toLowerCase() === 'industria' && user.dados.permissoes.view_labels_pgm_triplo){
			if (user.dados.permissoes.view_pgm) {
				getResumo(10, 1, '', '').then(res => {
					setCreditoValue(res?.data?.montante || 0)
				});
			}
		}else if(user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && user.dados.cargo.toLowerCase() !== 'distribuidor - filial' && user.dados.permissoes.view_labels_pgm_triplo){
			getSaldo(user.dados.documento, '').then(res => {
				if(res?.data && res?.data?.saldo){
					setCreditoValue(res?.data?.saldo || 0)
				}
			});
		}else{
			if (user.dados.permissoes.view_pgm) {
				getResumo(10, 1, '', '').then(res => {
					setCreditoValue(res?.data?.montante || 0)
				});
			}
		}

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	function redirectHome(){
		if (user.dados.permissoes.view_dashboard) {
			redirectTo = '/client/dashboard';
		}else{
			redirectTo = user.dados.permissoes.view_conciliacao ? '/client/dashboard' : '/client/transacoes';
		}
		return redirectTo;
	}

	function handleClickEventGA4(message) {
		ReactGA.event({
			category: message,
			action: message,
			label: message,
		});
	}

	return (
		<>
			{/* <Link to={user.dados.permissoes.view_dashboard
				? '/client/dashboard'
				: '/client/transacoes'}>
				<Logo />
			</Link> */}

			<Link to={redirectHome()} >
				<Logo onClick={() => handleClickEventGA4("retornar_home_logo_menu")} className={!isMobile ? sidebar.active ? 'logo-green' : 'logo-ee' : 'logo-mobile'} />
			</Link>

			<Bar>
				<Container fluid className="h-100">
					<Row
						className="d-flex align-items-center h-100"
						style={{ flexWrap: 'nowrap' }}>
						<Col sm="6" className="d-flex justify-content-start">
							<div className={`d-flex align-items-center ${sidebar.active ? ' sidebar-active-icon': ' sidebar-inactive-icon'} `}>
								{!isMobile &&
									<IconeMenu
										onClick={() =>
											setSidebar({
												...sidebar,
												active: !sidebar.active,
											})
										}>
										{sidebar.active ? (
											<MenuOpenOutlined />
										) : (
											<MenuOutlined />
										)}
									</IconeMenu>}
							</div>

							{!isMobile &&
								<WellcomeBox  user={user} />
							}
						</Col>
						<Col sm="2">
							{isMobile && creditoValue >= 0 ?
								<MeusCreditosInfo >
									<span>{user.dados.cargo.toLowerCase() === 'industria' ? 'CRÉDITO DISTRIBUIDOR' : (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && !user.dados.permissoes.view_labels_pgm_triplo) ? 'MONTANTE DE CRÉDITO' : 'MEUS CRÉDITOS'}</span>
									<p>{creditoValue.toLocaleString('pt-BR', {
										style: 'currency',
										currency: 'BRL',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2,
									})}</p>
								</MeusCreditosInfo>
								:
								<></>
							}
						</Col>

						<Col className="d-flex justify-content-end">
							{!isMobile &&
								<MasterUserBox user={user} />
							}
							<div className="d-flex justify-content-between" style={{ width: '70px' }}>
								{!isMobile ?
									<>
										{user.dados.permissoes.view_notificacoes &&
											<Notification dropdownOpen={dropdownOpenNotificacao} setDropdownOpen={setDropdownOpenNotificacao} notificacoes={notificacoes} dataNotification={dataNotification} />
										}
										<Perfil dropdownOpen={dropdownOpenPerfil} setDropdownOpen={setDropdownOpenPerfil} />
									</>
									:
									<>
										<ButtonCss
											className="d-flex align-items-center justify-content-center"
											onClick={() => handlerSair()}>
											<ExitToApp />
										</ButtonCss>
									</>

								}
							</div>
						</Col>
					</Row>
				</Container>
			</Bar>
			<Sidebar active={sidebar.active}>
				{sidebar.active && creditoValue >= 0 ?
					<MeusCreditosInfo >
						<span>{user.dados.cargo.toLowerCase() === 'industria' ? 'CRÉDITO DISTRIBUIDOR' : (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && !user.dados.permissoes.view_labels_pgm_triplo) ? 'MONTANTE DE CRÉDITO' : 'MEUS CRÉDITOS'}</span>
						<p>{creditoValue.toLocaleString('pt-BR', {
							style: 'currency',
							currency: 'BRL',
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						})}</p>
					</MeusCreditosInfo>
					:
					<MeusCreditosInfo />
				}


				<SidebarUl active={sidebar.active}>

						{layout === 'client' && (
							<ClientSidebar
								active={sidebar.active}
								setSubSidebar={setSubSidebar}
								closeSidebars={closeSidebars}
							/>
						)}

						<SidebarLi className="final" active={sidebar.active} onClick={() => handlerSair()}>
							<ExitToApp style={{color: color.secondary}} />
							<p>Sair</p>
						</SidebarLi>

				</SidebarUl>
			</Sidebar>

		</>
	);
}
